import { useState } from "react"
//FORM
import Input from '../../../shared/components/form/input'
import Button from '../../../shared/components/Button/Button'
import FormLayout from '../../../shared/components/FormLayout/FormLayout'

function FormRegion({ closeModal, data, handleSubmit, title, btnText, btCancelAction }) {

    const [region, setRegion] = useState(data || {})

    function handleChange(e) {
        setRegion({ ...region, [e.target.name]: e.target.value, label: e.target.value, value: e.target.value })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(region)
    }

    return (
        <FormLayout requiredLegend
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">
                        {btnText || 'Salvar'}
                    </Button>
                    {btCancelAction && (
                        <Button variant="cancel" onClick={btCancelAction}>
                            Cancelar
                        </Button>
                    )}
                </>
            }
        >
            <div className="form-group">
                <Input
                    type="text"
                    name="regionName"
                    required
                    text="Região"
                    handleOnChange={handleChange}
                    value={region.regionName || ""}
                />
            </div>
        </FormLayout>
    )
}

export default FormRegion
